export const PortesAnimal: {value: string; label: string}[] = [
  {
    value: 'pequeno',
    label: 'Pequeno',
  },
  {
    value: 'medio',
    label: 'Médio',
  },
  {
    value: 'grande',
    label: 'Grande',
  },
];


export const TiposDocilAnimal: {value: string; label: string}[] = [
  {
    value: '1',
    label: 'Sim',
  },
  {
    value: '0',
    label: 'Não',
  },
];

export const CoresAnimal: {value: string; label: string}[] = [
  {
    value: 'branco',
    label: 'Branco',
  },
  {
    value: 'camarelo',
    label: 'Caramelo',
  },
  {
    value: 'cinza',
    label: 'Cinza',
  },
  {
    value: 'dourado',
    label: 'Dourado',
  },
  {
    value: 'listrado',
    label: 'Listrado',
  },
  {
    value: 'marrom',
    label: 'Marrom',
  },
  {
    value: 'preto',
    label: 'Preto',
  },
  {
    value: 'preto-e-branco',
    label: 'Preto e Branco',
  },
  {
    value: 'rajado',
    label: 'Rajado',
  },
];
